import { TPermissionChecksState, TPermissionCheckStatus } from './types';

export function setPermissionCheck(
  state: TPermissionChecksState,
  payload: { permissionId: number; status: TPermissionCheckStatus },
) {
  state.checks[payload.permissionId] = payload.status;
}

export function resetPermissionChecks(state: TPermissionChecksState) {
  state.checks = {};
}
